import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';

/**
 * Custom unchecked checkbox icon used as the `icon` prop on MUI Checkbox components.
 * Uses a stroke-based 1px border outline, replacing MUI's default fill-based icon which
 * renders with a thicker, less refined appearance.
 */
export const UncheckedIcon = (props: SvgIconProps): ReactNode => (
  <SvgIcon
    {...props}
    data-testid={locator.components.uncheckedIcon.root}
    viewBox="0 0 24 24"
  >
    <rect
      fill="none"
      height="22"
      rx="2"
      stroke="currentColor"
      strokeWidth="1"
      width="22"
      x="1"
      y="1"
    />
  </SvgIcon>
);
